import { network } from './network';

export async function queryRechargePackage(opts) {
	const res = await network({
		url: '/api/v1/shop/gem_packages',
		method: 'post',
		params: {
			type: opts.type
		},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function createStripeOrder(opts) {
	const res = await network({
		url: '/api/v1/shop/stripe/create_order',
		method: 'post',
		params: {
			package_id: opts.package_id,
			success_url: opts.success_url,
			cancel_url: opts.cancel_url
		},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}
